<script>
export default {
  name: 'Agreement',
  data() {
    return {
      format: [7, 8, 14, 21, 24, 32, 34, 39, 42, 44, 46, 48, 50, 53, 55],
    };
  },
};
</script>

<template>
  <div class="launchpad-agreement page-content">
    <div class="main-wrap main-wrap--narrow">
      <p
        v-for="(paragraph, index) in $t('launchpad.disclaimer.undercut')"
        :key="index"
        :class="{
          'launchpad-agreement__title': !(index - 1),
          'launchpad-agreement__bold': format.includes(Number(index)),
        }"
      >
        {{ paragraph }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.launchpad-agreement {
  p {
    font-size: 1.8rem;

    &.launchpad-agreement__title {
      font-size: 3rem;
      font-weight: 700;
      margin-bottom: 5rem;
    }

    &.launchpad-agreement__bold {
      font-weight: 700;
    }
  }
}
</style>
